import { tenantCustomizationValues } from "./tenants";
import { TenantConfig, TenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import React from "react";
import { DEFAULT_TENANT_CONFIG } from "src/tenantCustomizations/defaultTenantConfig.ts";
import deepMerge from "src/utils/deepMerge.ts";

export const TenantCustomizationsContext = React.createContext<TenantCustomizations>({
	tenantConfig: DEFAULT_TENANT_CONFIG,
});

export interface TenantCustomizationsContextProviderProps {
	children: React.ReactNode;
}

export const TenantCustomizationsContextProvider = ({
	children,
}: TenantCustomizationsContextProviderProps) => {
	const tenantName = resolveTenantName();
	let customizations = tenantCustomizationValues[tenantName];
	if (customizations === undefined) {
		console.warn(`Unknown tenant ${tenantName}`);
		customizations = {};
	}
	const tenantConfig = deepMerge(
		DEFAULT_TENANT_CONFIG,
		customizations.tenantConfig ?? {},
	) as TenantConfig;
	const resolvedCustomizations = {
		...customizations,
		tenantConfig: tenantConfig,
	};

	return (
		<TenantCustomizationsContext.Provider value={resolvedCustomizations}>
			{children}
		</TenantCustomizationsContext.Provider>
	);
};

const resolveTenantName = () => {
	const domain = window.location.hostname;
	return domain.split(".")[0]!;
};
